import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">Privacy Policy</h1>
      
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">1. Information We Collect</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          GamePreBattle collects information you provide directly to us when you create an account, such as your name, email address, and password. We may also collect information about your use of our services, such as your predictions, game history, and virtual currency transactions.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">2. How We Use Your Information</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          We use the information we collect to:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
          <li>Provide, maintain, and improve our services</li>
          <li>Process transactions and manage your account</li>
          <li>Send you technical notices, updates, and administrative messages</li>
          <li>Respond to your comments, questions, and customer service requests</li>
          <li>Analyze usage patterns and trends to enhance user experience</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">3. Information Sharing</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          We do not share your personal information with third parties except in the following circumstances:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
          <li>With your consent</li>
          <li>To comply with legal obligations</li>
          <li>To protect our rights, privacy, safety, or property</li>
          <li>In connection with a merger, sale, or asset transfer</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">4. Data Security</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          We implement reasonable security measures to protect your personal information from unauthorized access, loss, misuse, or alteration. However, no data transmission over the internet or electronic storage is completely secure, so we cannot guarantee absolute security.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">5. Cookies and Tracking Technologies</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          GamePreBattle uses cookies and similar tracking technologies to track activity on our service and hold certain information. Cookies are files with a small amount of data that may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">6. Children's Privacy</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          GamePreBattle does not knowingly collect personal information from children under the age of 18. If we learn that we have collected personal information from a child under 18, we will take steps to delete that information as quickly as possible.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">7. Changes to This Privacy Policy</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">8. Contact Us</h2>
        <p className="text-gray-700 dark:text-gray-300">
          If you have any questions about this Privacy Policy, please contact us through our Support page.
        </p>
        
        <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">
          Last Updated: June 2023
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 